<template>
  <div v-if="!INSTALLED && showModal == false || !['ios', 'android'].includes(platform) && showModal == false"
    class="install-container">
    <button class="secret-button" @click="showModal = true">клик</button>
    <div class="install-container-desktop" v-if="!['ios', 'android'].includes(platform)">
      <img class="install-logo-desktop" src="@/assets/inv-gisuz-ru.png" alt="">
      <p>Воспользуйтесь QR-кодом для установки приложения <span>"ГИС УЗ - Инвентаризация"</span> на мобильном
        устройстве</p>
    </div>

    <img class="install-logo" v-if="['ios', 'android'].includes(platform)" src="../../public/logo_outline.svg" alt="">
    <p class="install-ios-message" v-if="['ios', 'android'].includes(platform)">ГИС УЗ - Инвентаризация</p>
    <p class="install-message">{{ platformMessage }}</p>
    <button v-if="showInstallButton && ['android'].includes(platform) && !visible" @click="installPWA"
      class="install-button">
      Установить приложение
    </button>


    <div v-if="platform === 'ios'" class="ios-hint">
      <button class="secret-button" @click="showModal = true">клик</button>
      <h4 class="ios-hint-title"> Установка приложения</h4>
      <div class="ios-hint-content">
        <div class="ios-hint-text">
          <p>1.</p>
          <p>Нажмите кнопку "Поделиться"
            <IOSExport class="ios-hint-icon-export" /> в нижней части экрана
          </p>
        </div>
        <div class="ios-hint-text">
          <p>2.</p>
          <p>Выберите "Добавить на экран"
            <IOSPlus class="ios-hint-icon-plus" />
          </p>
        </div>
        <div class="ios-hint-text">
          <p>3.</p>
          <p>В открывшемся окне нажмите "Добавить"</p>
        </div> <img class="ios-hint-img" src="@/assets/Инвентаризация.png" alt="">

        <div class="ios-hint-text">
          <p>4.</p>
          <p>На домашнем экране появится иконка приложения</p>
        </div>
      </div>
    </div>
    <div v-if="['android'].includes(platform)">
      <p class="important-message">Для установки приложения необходимо использовать браузер Google Chrome.</p>
    </div>
  </div>
  
  <div v-if="!INSTALLED && showModal == false || ['windows', 'mac', 'linux'].includes(platform) && showModal == false"
    class="install-container">
    <button class="secret-button" @click="showModal = true">клик</button>
    <div class="install-container-desktop" v-if="!['ios', 'android'].includes(platform)">
      <img class="install-logo-desktop" src="@/assets/inv-gisuz-ru.png" alt="">
      <p>Воспользуйтесь QR-кодом для установки приложения <span>"ГИС УЗ - Инвентаризация"</span> на мобильном
        устройстве</p>
    </div>

    <img class="install-logo" v-if="['ios', 'android'].includes(platform)" src="../../public/logo_outline.svg" alt="">
    <p class="install-ios-message" v-if="['ios', 'android'].includes(platform)">ГИС УЗ - Инвентаризация</p>
    <p class="install-message">{{ platformMessage }}</p>
    <button v-if="showInstallButton && ['android'].includes(platform) && !visible" @click="installPWA"
      class="install-button">
      Установить приложение
    </button>


    <div v-if="platform === 'ios'" class="ios-hint">
      <button class="secret-button" @click="showModal = true">клик</button>
      <h4 class="ios-hint-title"> Установка приложения</h4>
      <div class="ios-hint-content">
        <div class="ios-hint-text">
          <p>1.</p>
          <p>Нажмите кнопку "Поделиться"
            <IOSExport class="ios-hint-icon-export" /> в нижней части экрана
          </p>
        </div>
        <div class="ios-hint-text">
          <p>2.</p>
          <p>Выберите "Добавить на экран"
            <IOSPlus class="ios-hint-icon-plus" />
          </p>
        </div>
        <div class="ios-hint-text">
          <p>3.</p>
          <p>В открывшемся окне нажмите "Добавить"</p>
        </div> <img class="ios-hint-img" src="@/assets/Инвентаризация.png" alt="">

        <div class="ios-hint-text">
          <p>4.</p>
          <p>На домашнем экране появится иконка приложения</p>
        </div>
      </div>
    </div>
    <div v-if="['android'].includes(platform)">
      <p class="important-message">Для установки приложения необходимо использовать браузер Google Chrome.</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import IOSExport from './svg/IOSExport.vue';
import IOSPlus from './svg/IOSPlus.vue';
const showInstallButton = ref(false);
const platform = ref('');
const platformMessage = ref('');
const deferredPrompt = ref<any>(null);
const INSTALLED = ref(false);
const visible = ref(false);

const showModal = ref(false);
const installPWA = async () => {
  try {
    if (!deferredPrompt.value) {
      if (window.matchMedia('(display-mode: standalone)').matches) {
        platformMessage.value = 'Приложение уже установлено';
      } else {
        platformMessage.value = 'Приложение уже установлено';
      }
      visible.value = true;
      return;
    }

    deferredPrompt.value.prompt();

    const choiceResult = await deferredPrompt.value.userChoice;

    if (choiceResult.outcome === 'accepted') {
      showInstallButton.value = false;
      platformMessage.value = 'Приложение будет установлено на домашний экран';
    } else {
      platformMessage.value = 'Установка отменена'; // Добавляем сообщение об отмене
    }
  } catch (error) {
    console.error('Ошибка установки:', error);
    platformMessage.value = 'Произошла ошибка при установке';
    visible.value = true;
  }
};

onMounted(() => {
  const UA = navigator.userAgent;
  const IOS = UA.match(/iPhone|iPad|iPod/i);
  const ANDROID = UA.match(/Android/i);
  const WINDOWS = UA.match(/Windows/i);
  const MAC = UA.match(/Macintosh/i) && !IOS;
  const LINUX = UA.match(/Linux/i);

  platform.value = IOS ? 'ios' :
    ANDROID ? 'android' :
      WINDOWS ? 'windows' :
        MAC ? 'mac' :
          LINUX ? 'linux' :
            'other';

  const standalone = window.matchMedia('(display-mode: standalone)').matches;
  INSTALLED.value = !!(standalone || (IOS && !UA.match(/Safari/i)));

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt.value = e;
  });

  if (INSTALLED.value && ['android'].includes(platform.value)) {
    platformMessage.value = 'Приложение уже установлено';
    showInstallButton.value = false;
  } else if (!INSTALLED.value && ['android'].includes(platform.value)) {
    platformMessage.value = 'Установите приложение для дальнейшей работы';
    showInstallButton.value = true;
  }

  if (!INSTALLED.value && ['windows', 'mac', 'linux'].includes(platform.value)) {
    showInstallButton.value = true;
  }
})
</script>

<style scoped>
.install-container {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  min-height: fit-content;
  height: 100vh;
  background-color: #fff;
  text-align: center;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.install-container-desktop {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.install-container-desktop p {
  color: #333;
  font-weight: 500;
  font-size: 20px;
  max-width: 280px;
}

.install-container-desktop span {
  color: #3b82f6;
}

.secret-button {
  position: absolute;
  top: 0;
  right: 0;
  margin: 10px;
  padding: 10px;
  background-color: transparent;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.install-message {
  font-size: 18px;
  color: #666;
  font-weight: bold;
  margin-bottom: 20px;
  max-width: 280px;
}

.install-ios-message {
  color: #3b82f6;
  font-size: 24px;
  font-weight: normal;
}

.install-button {
  padding: 12px 24px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.install-button:hover {
  background-color: #2563eb;
}


.install-logo {
  display: block;
  margin: 0 auto;
  margin-bottom: 20px;
  width: 100%;
  max-height: 120px;
}

.install-logo-desktop {

  margin-bottom: 20px;

}

.ios-hint {
  max-width: 500px;
  padding: 16px;
}

.ios-hint-title {
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.ios-hint-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ios-hint-text {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: 8px;
  font-size: 15px;
  line-height: 1.4;
  color: #555;
}

.ios-hint-text p {
  text-align: start;
}

.ios-hint-text p:first-child {
  font-weight: 600;
  color: #333;
}

.ios-hint-img {
  width: 100%;
  max-width: 300px;
  height: auto;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.ios-hint-icon-export {
  width: 30px;
  height: 30px;
  display: inline-block;
  vertical-align: middle;
  transform: translateY(-4px);
}

.ios-hint-icon-plus {
  width: 22px;
  height: 22px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 4px;
  transform: translateY(-2px);
}
.important-message {
  font-size: 16px;
  color: #fd0000;
  font-weight: bold;
  margin-top: 20px;
  max-width: 400px;
}
</style>